export enum SentenceGradingFeedback {
  IMMEDIATE = 'IMMEDIATE',
  DELAYED = 'DELAYED',
}
